export type DueUrgency = 'overdue' | 'soon' | 'normal'

/** `--danger` si venció, `--warning` si vence hoy o mañana (CLAUDE.md §6). */
export function dueUrgency(dueDate: string): DueUrgency {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const due = new Date(`${dueDate}T00:00:00`)
  const diffDays = Math.round((due.getTime() - today.getTime()) / 86_400_000)

  if (diffDays < 0) return 'overdue'
  if (diffDays <= 1) return 'soon'
  return 'normal'
}

/** Fechas siempre con `Intl`, nunca formateadas a mano (CLAUDE.md §6). */
export function formatDueDate(dueDate: string, locale: string): string {
  const due = new Date(`${dueDate}T00:00:00`)
  return new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short' }).format(due)
}
